module.exports = __webpack_public_path__ + "static/mobile-5-314fb56fc5af97255f79d6d7dbc61de2.jpg";